import { memo } from 'react'
import { Stack, Typography } from '@mui/material'
type Props = {
    text: string
}
const EmptyView = (props: Props) => {

    return (
        <Stack direction={'column'} alignItems={'center'}>
           <Typography color="textSecondary" sx={{ textAlign: 'center' }} fontSize={'14px'}>
                {props.text}
            </Typography>
        </Stack>
    )
}

export default memo(EmptyView)